/**
 * 用户信息
 */

import { local } from '../plugin/storage'

const USER_KEY = '_user_'
const LOGIN_STATUS_KEY = '_login_status_'

export default {
  namespaced: true,

  state: () => ({
    user: local.get(USER_KEY) || {},
    loginStatus: local.get(LOGIN_STATUS_KEY) || 0
  }),

  getters: {
    user: state => {
      return state.user
    },
    loginStatus: state => {
      return state.loginStatus
    }
  },

  mutations: {
    setUser (state, user) {
      state.user = user
      local.set(USER_KEY, user)
    },

    setLoginStatus (state, status) {
      state.loginStatus = status
      local.set(LOGIN_STATUS_KEY, status)
    }
  }
}
